import AppIcon from 'components/common/AppIcon/AppIcon';
import { rgba } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { colors } from 'styles/shared';

const ItemRow = styled.div`
  height: 6.9rem;
  border-bottom: ${props => (props.lastItem ? null : `0.2rem solid ${rgba(colors.darkBlue_lighter, 0.3)}`)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

const Ellipse = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin-right: 1.5rem;
  background: ${props => props.color};
`;

const Title = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  width: 100%;
`;

const Panel = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  width: 100%;
  padding: 1rem;
`;

AccordionItem.propTypes = {
  item: PropTypes.object.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};

AccordionItem.defaultProps = {
  className: ''
};

function getItemDescription(item) {
  if (item.id === 1) {
    return 'You API key should be placed in the header X-Access-Token for all requests';
  } else if (item.id === 2) {
    return 'Billing is calculated as a base monthly fee which includes a number of API requests. Each additional API request is charged for. More information is available in the billing section';
  } else if (item.id === 3) {
    return 'You can see data for different destinations by using the Explore tab in the dashboard ';
  } else if (item.id === 4) {
    return (
      <span>
        You can find more documentation online&nbsp;
        <a href="https://documenter.getpostman.com/view/10808728/SzzgBzyZ?version=latest#9fd92143-20e4-4029-a215-b081d72734a2">
          here
        </a>
      </span>
    );
  } else if (item.id === 5) {
    return 'The User Itinerary service will be launched mid-October and will then be available through the dashboard';
  } else if (item.id === 6) {
    return 'You can contact us using the support tab in the dashboard';
    // Small billing
  } else if (item.id === 111) {
    return 'You simply add your card and you are charged your monthly fee plus any additional API requests over the included limit';
  } else if (item.id === 112) {
    return 'Any API requests that are over the monthly limit are charged at between $0.005 and $0.015 per request, depending on your plan';
  } else if (item.id === 113) {
    return 'We bill at the end of every calendar month';
  } else if (item.id === 114) {
    return 'You can see your monthly spend on the home page of the dashboard';
  } else if (item.id === 115) {
    return 'You can reach out to us using the contact form in the support area of the dashboard';
  } else if (item.id === 116) {
    return 'You can update your card in the billing section of the dashboard';
    // Small support
  } else if (item.id === 121) {
    return 'You can see advice for a given destination in the explore tab of the dashboard';
  } else if (item.id === 122) {
    return 'If you feel that your usage is not accurate, please contact us using the form in the support tab and we can assist';
  } else if (item.id === 123) {
    return 'While we try keep the data up to date, there may be some errors. Please let us know which destination is inaccurate and we will ivnestigate';
  } else if (item.id === 124) {
    return 'The User Itinerary Service will launch mid-October and will be available through the dashboard';
  } else if (item.id === 125) {
    return 'We schedule maintenance between 5am and 9am BST on Saturdays';
    // Big search
  } else if (item.id === 101) {
    return 'You can search by any top level country name, or any city name';
  } else if (item.id === 102) {
    return 'We provide the ability to search by any airport, you can simply use the three letter airport code e.g. LHR for London Heathrow';
  } else if (item.id === 103) {
    return 'When a trip is to a destination in a US state, we add US state specific data to the response';
  } else if (item.id === 104) {
    return 'Yes, we do an overall response for requirements across multiple destinations, as well as requirements and data for each destination';
  } else if (item.id === 105) {
    return 'We provide mask, quarantine and certification data for all destinations';
  } else if (item.id === 106) {
    return 'A full list of data can be seen in the explore tab and includes schools closing, public transport, restaurants closing and more';
  } else if (item.id === 107) {
    return (
      <span>
        You can find more documentation online&nbsp;
        <a href="https://documenter.getpostman.com/view/10808728/SzzgBzyZ?version=latest#9fd92143-20e4-4029-a215-b081d72734a2">
          here
        </a>
      </span>
    );
  } else if (item.id === 108) {
    return 'This is part of our User Itinerary service which will be launch mid-October';
  }
  return;
}

function AccordionItem({className, item, icon, selected, onClick}) {
  const panelText = item.content ? item.content : getItemDescription(item);

  return (
    <>
      <ItemRow lastItem={item.lastItem} className={className} onClick={onClick}>
        <ItemContainer>
          <Ellipse color={item.color} />

          <Title>{item.text}</Title>
        </ItemContainer>

        <AppIcon name={icon} />
      </ItemRow>

      {selected && <Panel>{panelText}</Panel>}
    </>
  );
}

export default AccordionItem;
